import React from "react";
import PropTypes from "prop-types";
import Button from "../elements/button";

/**
 * A modal header that includes a Save and Cancel button. The button styles should not be changed.
 * If a custom header is needed in the future, consider creating a separate component.
 */

const ModalHeaderWithActions = ({
  title,
  submitLabel = "Save",
  closeModal = () => { },
  onSubmit = () => { },
  disableSubmit = false,
  closeLabel = "Cancel"
}) => {
  return (
    <div className="et--modal-header">
      <h3>{title}</h3>
      <div className="et--modal-header--actions">
        <Button type="simple" onClick={closeModal}>
          {closeLabel}
        </Button>
        <Button type="default" disabled={disableSubmit} onClick={onSubmit}>
          {submitLabel}
        </Button>
      </div>
    </div>
  );
};

ModalHeaderWithActions.propTypes = {
  title: PropTypes.string.isRequired,
  submitLabel: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disableSubmit: PropTypes.bool,
  closeLabel: PropTypes.string,
};

export default ModalHeaderWithActions;
